var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TeamReport',{attrs:{"report-mode":"overview"}})
}
var staticRenderFns = []

export { render, staticRenderFns }